



















































import ApplicationModule from "@/store/modules/application";
import SnackbarModule from "@/store/modules/snackbar";
import { Component, Vue } from "vue-property-decorator";
import { State, namespace } from "vuex-class";
import { ApplicationState } from "@/models";

const application = namespace(ApplicationModule.name);
const snackbar = namespace(SnackbarModule.name);

@Component({
  name: "ApplicationNavbar"
})
export default class ApplicationNavbar extends Vue {
  // ===== Store ===== //
  @State("application") public application!: ApplicationState;
  @application.Action("getFacilities") public getFacilities!: () => void;
  @application.Action("getFacilityUnitTypes") public getFacilityUnitTypes!: () => void;
  @application.Action("toggleDrawer") public toggleDrawer!: () => void;
  @snackbar.Action("successMessage") public successMessage!: (message: string) => void;
  // ===== Data ===== //
  public loggedOut = false;
  public menuActive = false;
  public userProfile = `${this.$store.state.auth.profile.first_name} ${this.$store.state.auth.profile.last_name}`;
  // ===== Methods ===== //

  public logout(): void {
    this.loggedOut = true;
    this.$store.dispatch("auth/logout")
      .then(() => {
        window.close();
        this.$router.push("/login");
        this.successMessage("Logged out.");
      });
  }

  // ===== Lifecycle Hooks ===== //
  private created(): void {
    if (!this.application.facilitiesList.length) {
      this.getFacilities();
    }
    if (!this.application.facilityUnitTypes.length) {
      this.getFacilityUnitTypes();
    }
  }

  private mounted(): void {
    const issueScript = document.createElement("script");
    issueScript.setAttribute("src", "https://storespace.atlassian.net/s/d41d8cd98f00b204e9800998ecf8427e-T/-wkhk6e/b/45/a44af77267a987a660377e5c46e0fb64/_/download/batch/com.atlassian.jira.collector.plugin.jira-issue-collector-plugin:issuecollector/com.atlassian.jira.collector.plugin.jira-issue-collector-plugin:issuecollector.js?locale=en-US&collectorId=17af6ca7");
    document.head.appendChild(issueScript);

    const buttonScript = document.createElement("script");
    buttonScript.innerHTML =
      `window.ATL_JQ_PAGE_PROPS = {
              "triggerFunction": function(showCollectorDialog) {
                  jQuery("#feedback-button").click(function(e) {
                      e.preventDefault();
                      showCollectorDialog();
                  });
              },
          };`;
    document.head.appendChild(buttonScript);
  }
}
